/** Skyrise brand identity tokens (colour palette + patterns). */

export const BRAND = {
  /** Primary */
  ink: '#0a0a36',
  electric: '#0b1775',

  /** Secondary */
  padilla: '#776194',
  lavanda: '#6161d7',
  casa: '#f66d6b',
  hacienda: '#f3b547',

  /** Tint variants (on light surfaces) */
  ink_10: 'rgba(10, 10, 54, 0.1)',
  ink_50: 'rgba(10, 10, 54, 0.5)',
  electric_10: 'rgba(11, 23, 117, 0.1)',
  electric_50: 'rgba(11, 23, 117, 0.5)',
  lavanda_10: 'rgba(97, 97, 215, 0.1)',
  casa_10: 'rgba(246, 109, 107, 0.1)',

  /** Sidebar shell */
  siderBg: '#0a0a36',
  siderBorder: 'rgba(97, 97, 215, 0.32)',
  siderText: 'rgba(255, 255, 255, 0.85)',
  /** 0.62 alpha keeps muted labels/icons at 7.5:1 on the sider, 7.2:1 in a submenu. */
  siderTextMuted: 'rgba(255, 255, 255, 0.62)',
  siderItemHover: 'rgba(51, 80, 200, 0.6)',
  /** Reads as a distinct surface (2.09:1 vs siderBg) so selection is not carried by the accent bar alone. */
  siderItemActive: '#233bb0',
  siderSubmenuBg: 'rgba(11, 23, 117, 0.35)',
  siderAccent: '#6161d7',
  /** Group-heading label colour, dimmer than body but still legible. */
  siderHeading: 'rgba(255, 255, 255, 0.5)',

  /** Typography */
  fontFamily: "'Lato', 'Calibri', sans-serif",
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500
} as const;

/** Dot-matrix background overlay (brand activation). */
export const brandDotMatrixBg =
  'radial-gradient(rgba(255, 255, 255, 0.07) 1px, transparent 1px)';

export const brandDotMatrixSize = '18px 18px';
